import {UserService} from '../services/user.service';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class UsernameHeaderInterceptor implements HttpInterceptor {

  constructor(public userService: UserService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.userService.getCurrentUserName()) {
      request = request.clone({
        setHeaders: {
          username: this.userService.getCurrentUserName() ?
            encodeURIComponent(this.userService.getCurrentUserName()) :
            this.userService.getCurrentUserName()
        }
      });
    }
    return next.handle(request);
  }
}
